/* eslint-disable no-undef */
/**
 * Wrapper for analytics sending interface
 * @param {String} method - which method of analytics to use, "track" by default
 * @param {String} [eventName] - optional event name to track
 * @param {Object} params - will be passed into interface
 */
export default function sendEvent(method, eventName, params = {}) {
  try {
    // Check if analytics is available and initialized
    if (
      typeof window === 'undefined' ||
      !window.analytics ||
      window.analytics.blocked ||
      (window.analytics.initialize && !window.analytics.loaded)
    ) {
      // Analytics not loaded (blocked by extension or not initialized)
      return;
    }

    if (typeof eventName === 'string') {
      analytics[method](eventName, params);
    } else {
      analytics[method](eventName);
    }
  } catch (err) {
    // Silently fail if analytics is blocked or not available
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.log(
        `Error in analytics with method ${method}`,
        { eventName, params },
        err
      );
    }
  }
}
